<template>
  <div class="width100p">
    <!-- {{ calcsMenuOptions }} -->
    <div class="ma-4">
      <div class="d-flex flex-row justify-space-between">
        <div class="text-h4 grey--text text--darken-3">
          {{ title }}
          <v-fade-transition>
            <v-progress-circular
              v-if="!loaded && calcObj && calcObj.iframeUrl"
              indeterminate
              color="primary"
              class="ml-6"
            ></v-progress-circular>
          </v-fade-transition>
        </div>
        <router-link v-if="calcObj && calcObj.moreInfo" :to="calcObj.moreInfo"
          >Calculator Documentation
          <v-icon small color="primary">mdi-open-in-new</v-icon></router-link
        >
      </div>
      <v-divider class="mb-4"></v-divider>
    </div>
    <div
      v-if="calcObj && calcObj.key == 'vertex'"
      class="ma-4"
      style="max-width: 600px"
    >
      <quick-calcs :hideCloseButton="true"></quick-calcs>
      <div class="my-4 d-flex flex-row align-top caption">
        <v-img
          src="https://www.eyedock.com/images/menu_icons/quick_calcs_icon.svg"
          width="23"
          class="d-inline-block mr-4"
        ></v-img>
        <div>
          Note: This calculator is available on (almost) every page - just click
          the lightning icon at the top of the screen!
        </div>
      </div>
    </div>
    <div v-else-if="calcObj && calcObj.iframeUrl" class="ma-4 d-flex flex-row">
      <!-- <p>{{ selectedCalc.url }}</p> -->

      <iframe
        :src="'https://www.eyedock.com' + calcObj.iframeUrl"
        class="iframeDiv"
        :key="iframeUpdate"
        @load="load"
      ></iframe>
    </div>
    <calcs-menu v-else-if="!calc" :items="calcsMenuOptions"></calcs-menu>
  </div>
</template>

<script>
import CalcsMenu from "@/components/calcsStuff/CalcsMenu.vue";
import GetJsonMixin from "@/assets/js/GetJsonMixin";
// import calcsMenuOptions from "../../assets/js/calcs/calcsMenuOptions";
// import calcsMenuOptions from "../../assets/js/calcs/calcsMenuOptions";

// import CalcsMenuOptions from "@/assets/js/calcs/calcsMenuOptions";

// import Name from "../dir/file";

export default {
  components: {
    CalcsMenu,
    QuickCalcs: () => import("@/components/calcsStuff/QuickCalcs.vue"),
  },
  mixins: [GetJsonMixin],
  name: "CalcsHome",
  props: {},
  data: function () {
    return {
      iframeUpdate: false,
      calcObj: null,
      loaded: false,
      calcsMenuOptions: null,
      calc: null,
    };
  },
  methods: {
    load() {
      this.loaded = true;
    },
    calcObjectForKey(key) {
      let rtn = null;
      for (const calc of this.calcsMenuOptions) {
        if (calc.key == key) rtn = calc;
      }
      return rtn;
    },
  },
  computed: {
    title: function () {
      let rtn = "Calculators & Utilities";
      if (this.calcObj) rtn = this.calcObj.name;
      return rtn;
    },
  },
  watch: {
    calcsMenuOptions(val) {
      if (val && this.calc) {
        this.calcObj = this.calcObjectForKey(this.calc);
        // this.iframeUpdate = !this.iframeUpdate;
      }
    },
  },

  mounted: function () {
    // console.log("mounting");
    this.getJSON("calcMenuOptions", "calcsMenuOptions"); // in the mixin
    this.calc = this.$route.params.calc;
    // console.log(calc);
    if (this.calc) this.iframeUpdate = !this.iframeUpdate;
  },
  metaInfo() {
    return {
      title: "EyeDock/Calcs | " + this.title,
    };
  },
};
</script>

<style scoped>
.iframeDiv {
  width: 100%;
  height: calc(100vh - 160px);
  border: none;
}
</style>
